import __base_store from '@/store/__base_store'

/**
 * Store de recargos por tipo de precio (modelo `price_type_surchage`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'price_type_surchage',
	},
})

